import { render, staticRenderFns } from "./ClientOnlyPrice.vue?vue&type=template&id=512c8c0f&scoped=true&"
import script from "./ClientOnlyPrice.vue?vue&type=script&lang=ts&"
export * from "./ClientOnlyPrice.vue?vue&type=script&lang=ts&"
import style0 from "./ClientOnlyPrice.vue?vue&type=style&index=0&id=512c8c0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c8c0f",
  null
  
)

export default component.exports